const ChannelDetailsView = async () => import('@/views/report/ChannelDetailsView.vue')
import type { _RouteLocationBase } from 'vue-router'

export default [
  {
    path: '/report/channel/:id',
    name: 'ChannelDetails',
    component: ChannelDetailsView,
    props: (route: _RouteLocationBase) => {
      return { id: parseInt(route.params.id as string) }
    }
  }
]
